import { useMutation } from "@apollo/client";
import { GENERATE_GOOGLE_REVIEW_REPLY_MUTATION } from "@/graphql/google-business";
import { useAsyncAction } from "@/lib/hooks/use-async-action";

export function useAiReviewReply() {
  const [generate] = useMutation(GENERATE_GOOGLE_REVIEW_REPLY_MUTATION);

  const generateReply = useAsyncAction(
    async (reviewId: string) => {
      const result = await generate({ variables: { reviewId } });
      return result.data?.generateGoogleReviewReply?.suggestedReply ?? null;
    },
    {
      loadingMessage: "Generating AI reply...",
      errorMessage: "Could not generate AI reply",
    }
  );

  return {
    generate: generateReply.execute,
    generating: generateReply.isLoading,
  };
}
